import { RobotStatusState } from '@common/interfaces/robot/status/robot-state';
import TorizonUpdateStatus from '../enums/torizon-update-status';

// isUpdating is the robot webapp's boolean; the cloud reads torizonUpdateStatus instead.
interface RobotStatus extends Omit<RobotStatusState, 'isUpdating'> {
  robotId: string;
  lastConnection: string | null; // iso string
  roomName: string | null;
  active: boolean;
  unsentMissions: number | null;
  torizonUpdateStatus: TorizonUpdateStatus;
}

export default RobotStatus;

export const isRobotStatus = (input: any): input is RobotStatus => {
  return input != null && 'lastConnection' in input && 'state' in input && 'active' in input;
};
